import { Component, OnInit, Input, Inject } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ModalAlertComponent } from '../modal-alert/modal-alert.component';
import { Messages } from '@app/shared/enums/messages.enums';

@Component({
  selector: 'app-assing-modal',
  templateUrl: './assing-modal.component.html',
  styleUrls: ['./assing-modal.component.scss']
})
export class AssingModalComponent implements OnInit {
  @Input() title;
  assigmentForm: FormGroup;
  elements: any[] = [];

  constructor(
    private fb: FormBuilder,
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<AssingModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.elements = data.data;
  }

  ngOnInit() {
    this.assigmentForm = this.fb.group({
      selection: [null, Validators.required]
    });
  }

  assing(): void {
    const dialog = this.dialog.open(ModalAlertComponent, {
      width: '600px',
      disableClose: true,
      data: {
        questionConfirm: Messages.areYouSureSave
      }
    });

    dialog.componentInstance.acceptFN.subscribe(_ => {
      const selection = this.assigmentForm.get('selection').value;
      this.close(selection);
      dialog.close();
    });
  }

  close(selection?: any): void {
    this.dialogRef.close(selection);
  }
}
